export default __webpack_public_path__ + "static/media/cp_geo_nr.e40b9e0c.svg";